<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-fast-forward`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.317 8.499l16 13.996c.414.362.64.852.677 1.354L24 24V24l-.006.15a1.99 1.99 0 01-.677 1.355l-16 13.996C6.024 40.633 4 39.715 4 37.997V10.003C4 8.286 6.024 7.367 7.317 8.5zm20 0l16 13.996a2 2 0 010 3.01l-16 13.996C26.024 40.633 24 39.715 24 37.997V10.003c0-1.717 2.024-2.636 3.317-1.504zM8 14.409V33.59L18.963 24 8 14.41zm20 0V33.59L38.963 24 28 14.41z"/></svg>
</template>
<script>

export default {
  name: 'IconFastForward',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
